import { useEffect, useState } from 'react';
import { BunkerBadge } from './components/bunker-badge';
import { DataCardBadge } from './components/data-card';
import { MixStepsBadge } from './components/mix-steps';
import { SchiberBadge } from './components/schiber';
import { TotalCardBadge } from './components/total-card';
import styles from './single-bunker.module.sass';
import singleBunker from '@/modules/mixing/images/single-bunker.png';
import { TopWidget } from '../top-widget';

export const SingleBunker = ({ displayModal, data, activePair, setActivePair }: ISingleBunker) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  // const mockData = {
  //   gluten: 0,
  //   idk: 0,
  //   protein: 0,
  //   humidity: 0,
  //   cp: 0,
  //   nature: 0,
  // };
  return (
    <div
      className={styles.body}
      style={
        {
          //transform: windowWidth > 1680 ? 'scale(1.25)' : 'none'
        }
      }
    >
      <TopWidget data={data} activePair={activePair} setActivePair={setActivePair} />
      {/* <div className={styles.schiber}>
        <SchiberBadge multi={true} mirroring={true} />
      </div> */}
      <div className={styles.rows}>
        <div className={styles.firstRow}>
          <DataCardBadge
            data={data?.part_one.params}
            weight={data?.steps[activePair]?.info?.part_one?.weight}
            id={data?.steps[activePair]?.info?.part_one.bag_id}
            title={data?.steps[activePair]?.info?.part_one.warehous_name}
            price={data?.steps[activePair]?.info?.part_one.price}
          />

          <DataCardBadge
            data={data?.part_two.params}
            weight={data?.steps[activePair]?.info?.part_two.weight}
            id={data?.steps[activePair]?.info?.part_two.bag_id}
            title={data?.steps[activePair]?.info?.part_two.warehous_name}
            price={data?.steps[activePair]?.info?.part_two.price}
          />
          <BunkerBadge label={data?.steps[activePair]?.bp_name_1} />
        </div>
        <div className={styles.secondRow}>
          <MixStepsBadge stepsCount={data?.steps[activePair]?.steps?.length} onClick={displayModal} />
          <TotalCardBadge
            data={data?.result?.params}
            weight={data?.steps[activePair]?.info?.result.weight}
            price={data?.steps[activePair]?.info?.result.price}
            profit={data?.steps[activePair]?.info?.result.price_delta}
          />
        </div>
      </div>

      <img className={styles.bodyBg} src={singleBunker} alt="bunker" />
    </div>
  );
};

interface ISingleBunker {
  displayModal: () => void;
  data: any;
  activePair: number; 
  setActivePair: (val: number) => void
}
